<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          ERP OrderNo：{{ formData.erpOrderNo || '' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update time：{{ formData.updatedTime || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Creation time：{{ formData.creationTime || '--' }}
        </span>
      </div>
    </div>
    <el-form ref="form" :model="formData" size="small">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="'行状态'">
            <el-input v-model="formData.v_lineStatus" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="'上传信息状态'">
            <el-input v-model="formData.v_uploadStatus" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="'上传处理时间'">
            <el-input v-model="formData.uploadTime" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="'客户名称'">
            <el-input v-model="formData.custName" readonly />
          </el-form-item>
        </el-col>

        <el-col :span="16">
          <el-form-item :label="'错误信息'">
            <el-input v-model="formData.errorMsg" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="'订单信息'">
            <el-input
              type="textarea"
              :rows="12"
              v-model="formData.orderData"
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  mixins: [],
  components: {},
  props: {
    receiveLineCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {
        buyerCode: '',
        buyerName: '',
        totalQty: 0,
        totalAmount: 0,
        totalCtnQty: 0,
        totalGrossWeight: 0,
        totalCbm: 0,
      },
    }
  },

  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    reload() {
      this.getData()
      this.$refs.skuTable.getData()
    },
    getData() {
      if (!this.receiveLineCode) return
      this.$api
        .thdapiIyeedOrderReceiveLineDetailApi({
          receiveLineCode: this.receiveLineCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },

    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
